/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {DefaultComponentProps} from '@interface/common'


/**
 * Components
 */
import Button from '@components/button'


/**
 * Alert
 */
export default pure(({auth}: {data:any} & DefaultComponentProps) => {
  return (
    <div
      className="alert"
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <h4>Session Expired</h4>
      <p>Your session has expired due to inactivity. Please log in again to continue.</p>
      <Button
        label={'Login Again'}
        onClick={() => {
          auth.logout()
        }}
        className={'button-3'}
      />
    </div>
  )
})